module.exports = __webpack_public_path__ + "static/media/bacon-strip-emoji.5d6a055e.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/bacon-strip-emoji.png
// module id = 10
// module chunks = 0